/**
 * "Carregando equipamentos da frota", a partir do rotulo da tabela — a frase
 * do manual (p.60), e nao "Aguarde...". A inicial so desce quando a segunda
 * letra ja e minuscula: sigla ("O.S. abertas") fica como esta.
 */
export function carregandoA(rotulo: string): string {
  const segunda = rotulo.charAt(1);
  const inicio =
    segunda !== '' && segunda === segunda.toLocaleLowerCase('pt-BR') && segunda !== segunda.toLocaleUpperCase('pt-BR')
      ? rotulo.charAt(0).toLocaleLowerCase('pt-BR')
      : rotulo.charAt(0);
  return `Carregando ${inicio}${rotulo.slice(1)}`;
}
